import { render, staticRenderFns } from "./asinChildChangeModal.vue?vue&type=template&id=6df81e8c"
import script from "./asinChildChangeModal.vue?vue&type=script&lang=js"
export * from "./asinChildChangeModal.vue?vue&type=script&lang=js"
import style0 from "./asinChildChangeModal.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports